<template lang="pug">
.login-page.flex.align-stretch
  .left.flex.justify-center.align-center
    .logo.flex.justify-center.align-center
      img(src="/image/long-logo.png")
  .right.flex.align-center.justify-stretch
    .form.flex.column.align-stretch.gap-30
      .title 預約管理系統密碼重設
      .column.flex.column.gap-12
        .col-title 請輸入更新密碼
        el-input(type="password", v-model="password", show-password)
      .column.flex.column.gap-12
        .col-title 請再次輸入新密碼
        el-input(type="password", v-model="passwordRepeat", show-password)
        .validate-err(v-if="errRepeat") 兩次輸入的密碼不一致
      .validate-err(v-if="!token") 連結無效，請重新申請重設密碼
      el-button(
        type="primary", size="small", @click="updatePassword",
        :disabled="!canUpdatePassword") 更新密碼
  </template>

<script>
import { mapMutations } from 'vuex';
import {
  updatePasswordByToken,
} from '@/api/auth';

export default {
  name: 'Login',
  data() {
    return {
      token: '',
      password: '',
      passwordRepeat: '',
    };
  },
  computed: {
    errRepeat() {
      return this.passwordRepeat !== '' && this.password !== this.passwordRepeat;
    },
    // 網址缺少 token 時 URLSearchParams.get 回傳 null，需一併擋下
    canUpdatePassword() {
      return !!this.token && this.password !== '' && this.password === this.passwordRepeat;
    },
  },
  methods: {
    ...mapMutations(['setUserInfo']),
    async updatePassword() {
      this.$execWithLoading(async () => {
        await updatePasswordByToken(this.token, this.password);
        this.$showSuccess('更新密碼成功，請重新登入');
        this.$router.push({ name: 'Login' });
      }, (e) => {
        this.$showAxiosException('更新密碼失敗，連結可能已失效，請重新申請忘記密碼', e);
        this.$router.push({ name: 'Login' });
      });
    },
  },
  mounted() {
    this.setUserInfo(undefined);
    const queryString = window.location.hash.replace('#/forget-password', '');
    const urlParams = new URLSearchParams(queryString);
    this.token = urlParams.get('token');
  },
};
</script>

  <style lang="scss" scoped>
  @import '@/assets/style/variables.scss';

  .login-page {
    .left {
      background: #5AB0AC;
      flex: 1;
      .logo {
        background: white;
        flex: 0 0 383px;
        height: 80px;
        border-radius: 70px;
        img {
          width: 269px;
        }
      }
    }
    .right {
      background: white;
      flex: 0 0 415px;
      .form {
        flex: 1;
        padding: 40px;
        text-align: left;

        .title {
          font-size: 24px;
        }

        .link {
          color: $primary-color;
          text-decoration: underline;
        }

        .seperator {
          height: 1px;
          background: #DCDFE6;
        }

        .validate-err {
          color: $danger-color;
        }
      }
    }
  }
  </style>

  <style lang="scss">
  .validator {
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    input[type=number] {
      -moz-appearance: textfield;
    }
  }
  </style>
